module.exports = __webpack_public_path__ + "img/logo.84c1c4eb.svg";